import React, { FC, useState } from 'react';

import { useForm } from 'react-hook-form';

import { USER_EDITOR_FIELDS } from 'constants/edit-user';
import { UpdatedUserData } from 'interfaces';
import { useAppDispatch } from 'modules/store';
import { editUser } from 'modules/users/action';
import { AlertModal, FormContent, SnippetLayout } from 'shared-components';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  id?: string;
  defaultFirstName?: string;
  defaultLastName?: string;
  defaultEmail?: string;
  callback?: VoidFunction;
};

const EditUserModal: FC<Props> = ({
  isOpen,
  onClose,
  id,
  callback,
  defaultEmail,
  defaultFirstName,
  defaultLastName,
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm<UpdatedUserData>({
    defaultValues: {
      firstName: defaultFirstName || '',
      lastName: defaultLastName || '',
      email: defaultEmail || '',
    },
  });

  const onSubmit = () => {
    if (id) {
      setIsLoading(true);

      dispatch(
        editUser({
          id,
          firstName: watch('firstName') ?? defaultFirstName,
          lastName: watch('lastName') ?? defaultLastName,
          email: watch('email') ?? defaultEmail,
        }),
      )
        .unwrap()
        .then(() => {
          onClose();
          setIsLoading(false);

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <AlertModal
      isLoading={isLoading}
      onSubmit={onSubmit}
      onClose={onClose}
      isOpen={isOpen}
      title={'Edit User Data'}
      submitButtonText='Save'
      description='Now you can change data of this user'
    >
      <form className='w-full mb-0 mt-4'>
        <SnippetLayout childrenClassName='w-full flex flex-col'>
          <FormContent fields={USER_EDITOR_FIELDS} control={control} register={register} errors={errors} />
        </SnippetLayout>
      </form>
    </AlertModal>
  );
};

export default EditUserModal;
